module.exports = __webpack_public_path__ + "img/terms-bg@tl.5cf7b95.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/terms-bg@tl.svg
// module id = cS8k
// module chunks = 7